// extracted by mini-css-extract-plugin
export var container = "_7c-0";
export var containerTopRight = "_7c-1";